<template>
  <section
    class="hero is-fullheight login-form"
    :style="{ '--primary-color': $primaryColor }"
  >
    <div class="hero-body">
      <div class="container">
        <form @submit.prevent="login" class="has-text-centered">
          <b-loading
            :is-full-page="true"
            :active="isLoading"
            :can-cancel="false"
          ></b-loading>

          <div class="columns">
            <div class="column"></div>
            <div class="column is-half has-text-centered">
              <figure
                class="image"
                style="max-width: 400px; margin: auto; margin-bottom: 1rem;"
                v-if="$chain === 'mq'"
              >
                <logo-mq />
              </figure>

              <figure
                class="image"
                style="max-width: 250px; margin: auto; margin-bottom: 1rem;"
                v-else-if="$chain === 'brmania'"
              >
                <logo-brmania />
              </figure>

              <figure
                class="image"
                style="max-width: 170px; margin: auto; margin-bottom: 1rem;"
                v-else
              >
                <logo-smart-orange-outline />
              </figure>

              <h1
                class="is-size-3 has-text-weight-semibold"
                v-if="$chain === 'onii'"
              >
                Merchant
              </h1>
              <br />

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="email"
                  class="is-expanded"
                  type="email"
                  :placeholder="$t('common.email')"
                ></b-input>
              </b-field>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="password"
                  class="is-expanded"
                  type="password"
                  :placeholder="$t('common.password')"
                  password-reveal
                ></b-input>
              </b-field>

              <router-link to="forgot-password">
                <h3 class="is-size-6 has-text-deep-purple has-text-left">
                  {{ $t("login.forgotPassword") }}
                </h3>
              </router-link>
              <br />

              <button
                class="button is-medium is-fullwidth has-text-weight-bold"
                :style="{
                  backgroundColor: $primaryColor,
                  color: $primaryColorContrast
                }"
              >
                {{ $t("login.signIn") }}
              </button>
            </div>
            <div class="column"></div>
          </div>
        </form>
      </div>
    </div>

    <div class="hero-footer">
      <flag-icons />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common.js";
import flagIcons from "./common/FlagIcons";
import logoSmartOrangeOutline from "./common/logo-onii-smart-orange-outline-tagline";
import logoMq from "./common/logo-mq";
import logoBrmania from "./common/logo-brmania";

export default {
  mixins: [common],

  components: {
    flagIcons,
    logoSmartOrangeOutline,
    logoMq,
    logoBrmania
  },

  data() {
    return {
      email: "",
      password: "",
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["locale"])
  },

  methods: {
    login() {
      this.isLoading = true;
      this.$store
        .dispatch("login", {
          email: this.email,
          password: this.password
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$store.dispatch("setLocale", this.locale).then(() => {
              this.$i18n.locale = this.locale;
              this.$router.push("dashboard");
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
.login-form input.input:focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0.4em 0 rgba(0, 0, 0, 0.1), 0 0 0.15em 0 var(--primary-color) !important;
}
.login-form .password-reveal {
  color: var(--primary-color);
}
.login-form .password-reveal .icon {
  color: inherit;
}
</style>
